import axios from 'axios'

const service = axios.create({
  baseURL: 'https://api.iot.zs-tek.com/',
  // baseURL: 'http://192.168.2.18:1111/',
  // baseURL: 'http://localhost:12398/',
  withCredentials: true,
  timeout: 60 * 1000,
})

// 请求拦截
service.interceptors.request.use(
  config => {
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截
service.interceptors.response.use(
  response => response.data,
  error => {
    if (error.request.status === 403) { console.log('403') }
    return Promise.reject(error)
  }
)

export default service